// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SafetyAnchorPointListPagingResultModel from '../../model/safety-anchor-point-list-paging-result-model';
import SafetyAnchorPointListPagingResultDTO from '../dto/safety-anchor-point-list-paging-result-dto';
import dtoSchema from '../schemas/safety-anchor-point-list-paging-result-schema';
import SafetyAnchorPointListModel from '../../model/safety-anchor-point-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class SafetyAnchorPointListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SafetyAnchorPointListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SafetyAnchorPointListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: SafetyAnchorPointListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<SafetyAnchorPointListPagingResultDTO>): SafetyAnchorPointListPagingResultModel;
  static toModel(dto: DeepPartial<SafetyAnchorPointListPagingResultDTO> | undefined | null): SafetyAnchorPointListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<SafetyAnchorPointListPagingResultDTO> | undefined | null): SafetyAnchorPointListPagingResultModel | undefined {
    return dto ? new SafetyAnchorPointListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SafetyAnchorPointListPagingResultModel> | SafetyAnchorPointListPagingResultModel): SafetyAnchorPointListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as SafetyAnchorPointListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SafetyAnchorPointListPagingResultModel, can not map to SafetyAnchorPointListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
